import script from "./CallAnalysisAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallAnalysisAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./CallAnalysisAccordion.vue?vue&type=style&index=0&id=12ff5c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ff5c2e"]])

export default __exports__